<template>
  <parallax :fixed="fixed">
    <img :src="image" alt="Parallax Image" />
  </parallax>
</template>

<script>
import Parallax from 'vue-parallaxy';

export default {
  name: 'TheParallax',
  components: {
    Parallax,
  },
  props: {
    image: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fixed: true,
    };
  },
};
</script>

<style lang="scss" scoped>
div.Masthead {
  min-height: 200px;

  img {
    width: 100%;
    -webkit-filter: brightness(50%) grayscale(100%);
    filter: brightness(50%) grayscale(100%);
    overflow: hidden;
  }
}
</style>
